import {
  isEVMChain,
  type ChainIdParameter,
  type ChainType,
  type ClientType,
  type EVMChain,
} from '@particle-network/connector-core';
import type { Config } from '../createConfig';

export function getClient<chainType extends ChainType = EVMChain>(
  config: Config,
  parameters: ChainIdParameter = {}
): ClientType<chainType> | null {
  const chainId = parameters.chainId || config.state.chainId;
  const chain = config.chains.find((chain) => chain.id === chainId);

  if (!chain) {
    return null;
  }

  const authWalletConnector = config.getWalletConnector('particleAuth');
  if (authWalletConnector) {
    return authWalletConnector.getClient(chainId) as ClientType<chainType>;
  }

  if (isEVMChain(chain)) {
    return config.getWalletConnector('evmWallet')!.getClient(chainId) as ClientType<chainType>;
  }

  return config.getWalletConnector('solanaWallet')!.getClient(chainId) as ClientType<chainType>;
}
